var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t("overview.finance.takings.header")))]),_c('vca-row',[_c('div',{staticClass:"clickable",on:{"click":function($event){return _vm.navigate()}}},[_vm._v(" "+_vm._s(_vm.$t("overview.finance.takings.missing"))+" ")]),_c('div',{staticClass:"bold"},[_vm._v(_vm._s(_vm.missingTakings))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }